import { forwardRef } from 'react';
import { ActionBar } from '@frontend/action-bar';
import { useTranslation } from '@frontend/i18n';
import { taskCenterTrackingIds } from '@frontend/task-center';
import { useTaskCenterStore } from '@frontend/task-center-scope';
import { TopBarFocusIds } from '../../utils/focus-registry';

export const TaskCenterButton = forwardRef<HTMLButtonElement>((props, ref) => {
  const { t } = useTranslation('task-center');
  const { isTaskCenterOpen, setIsTaskCenterOpen } = useTaskCenterStore(['isTaskCenterOpen', 'setIsTaskCenterOpen']);
  const onClickButton = () => setIsTaskCenterOpen(!isTaskCenterOpen);
  return (
    <ActionBar.Action
      label={t('Task Center')}
      id={TopBarFocusIds.taskCenter}
      icon='mark-done'
      isActive={isTaskCenterOpen}
      onClick={onClickButton}
      trackingId={taskCenterTrackingIds.topBarButton}
      ref={ref}
      {...props}
    />
  );
});
TaskCenterButton.displayName = 'TaskCenterButton';
